export class StringHelper {

    public static readonly empty: string = '';

    public static isString(value: any): boolean {
        return typeof value === 'string';
    }

    public static isNullOrWhitespace(value: string): boolean {
        return !value || !value.trim();
    }

}